const { instructorList,instructorCourseList } = require("constants/instructor");

const initialState = {
  instructorList: {},
  instructorCourseList:{},
};

const instructor = (state = initialState, action) => {
  switch (action.type) {
    case instructorList:
      return { ...state, instructorList: action.payload };

    case instructorCourseList:
      return { ...state, instructorCourseList: action.payload };
      
    default:
      return state;
  }
};
export default instructor;
